/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Component } from 'react';
import { 
  buildErrorMsgFromForm, 
  cleanCopy, 
  validPhoneNumber,
  getBase64,
  userIsVerfied,
  userHasRole,
  copyToClipboard,
  getConfig,
  getAllLnsFromUser,
  mergeTableEdits,
  searchTable,
  testPassword,
  PWReqsMessage,
} from '../../actions/utils';
import { withRouter } from 'react-router-dom';
import Logo from '../../_shared/logo';
import { Form, Input, Alert, Select, Upload, Icon, message, Modal, Tag, Tooltip } from 'antd';
import SStyles from '../../_shared/styles';
import { Button } from '../../_shared/button';
import NumberedHeader from '../../_shared/numbered-header';
import { cols } from '../../authentication/sign-up';
import styles from './profile.styles';
import { flatten, get, merge, set, uniqBy } from 'lodash';
import { updateUser, createUser, getUserById, deleteUser, requestLicenseChange, approveLicenseChange, getAssignedLicenses, resetUserPassword, impersonateUser, getMfaStatus, enrollMfa, activateMfa, disableMfa, getAdminEmails } from '../../_shared/services/manage-users.service';
import { MultiSelectSearch } from '../../_shared/multi-select-search';
import ScreenTitle from '../../_shared/screen-title';
import Link from '../../_shared/link';
import Row from '../../_shared/row';
import { ROLES, _Account } from '../../models/account';
import { sendEmail } from '../../_shared/services/email.service';
import CONFIG from '../../config';
import LNSearch from '../../_shared/ln-search';
import colors from '../../_shared/colors';
import ScreenComponent from '../../_shared/hooks/useScreen';
import { Sigpad } from '../../_shared/sigpad';
import { getUsersMatchingLn } from '../../_shared/services/authentication.service';
import { EditableFormTable } from '../../_shared/editable-table';

const config = CONFIG();

const Cols = cleanCopy(cols);
Cols[0].selected = false;
Cols[1].selected = false;
Cols[2].selected = true;

const formWidth = 500;
const padding = 10;
const uploadwidth = 112;

const VERIFIYOPTIONS = [
  { title: 'Verified', value: true },
  { title: 'Suspended', value: 'suspended' },
  { title: 'Not Verified', value: false },
]

const USER_COLS = [
  {
    title: 'Email',
    dataIndex: 'email',
  },
  {
    title: 'Verified',
    dataIndex: 'data.verified',
    editable: true,
    inputType: 'select',
    // Card #277 — mirror what editable-table's returnRender() actually paints here. A
    // truthy value resolves through the options to its title ("Verified", "Suspended"),
    // but a falsy one falls through to this column's own render, so an unverified account
    // literally reads "false" on screen and has to be findable by that word rather than
    // by the option title "Not Verified", which is never displayed.
    searchValue: r => {
      const val = get(r, 'data.verified');
      if (!val) { return `${val}`; }

      // Compared as strings, the same way selectOptionTitle() in utils does it.
      return get(VERIFIYOPTIONS.find(o => `${o.value}` === `${val}`), 'title', '');
    },
    options: VERIFIYOPTIONS,
    render: (text) => {
      return `${text}`
    }
  }
]

class ProfileComponent extends Component {
  state = {
    error: null,
    success: null,
    loading: true,
    user: this.props.sState.user,
    imageUrl: '',
    isCreate: false,
    isNewUser: false,
    editAccount: false,
    // Add User modal (card #160). `error` (card #288 round 2) is the rejection the
    // modal keeps on screen — see submitAddUser.
    addUserModal: { visible: false, email: '', password: '', loading: false, error: null },
    addUserResult: null, // { email, tempPassword }
    // Reset Password result display — confirmation that a reset LINK was emailed
    resetPwResult: null, // { email }
    // MFA panel (superadmin)
    mfa: { loading: false, status: null, qrDataUrl: null, code: '' },
    // Card #277 — search box over the Attached Accounts grid
    attachedSearch: '',
    toDisplay: [
      {
        title: 'Email',
        var: 'email',
        canDisplay: () => this.state.isNewUser,
        options: {
          validateTrigger: 'onBlur',
          rules: [
            {
              type: 'email',
              message: 'The input is not a valid E-mail. ',
            },
            {
              required: true,
              message: 'The input is not a valid E-mail. ',
            },
          ],
        },
      },
      {
        title: 'Company Logo',
        var: 'company.logo',
        type: 'imageupload',
        styles: `
          float: left;
          width: ${uploadwidth + padding}px;
        `
      },
      {
        title: 'Company Name (LLC)',
        var: 'company.Licensee',
        styles: `
          float: left;
          width: ${this.props.screen.isMobile ? 'auto' : formWidth - uploadwidth - padding}px;
          padding-left: ${padding};
          clear: right;
        `,
        options: {
          rules: [
            {
              required: true,
              message: 'Company Name is required. ',
            },
            {
              max: 100,
              message: 'Company Name is limited to 100 characters. ',
            },
          ],
        },
      },
      {
        title: 'Company Name (DBA)',
        // Edits the real company.DBA — the key the app renders (e.g. the
        // Shipping Dashboard header fallback). Historically this field wrote
        // only company['Licensee DBA'] (a key nothing reads) while company.DBA
        // stayed frozen at signup (card #11 round 16). On load, prefer the
        // legacy key when set — it holds what the user last typed here — and
        // keep it in sync on save (see submit()).
        var: 'company.DBA',
        val: user => get(user, 'company.Licensee DBA') || get(user, 'company.DBA'),
        styles: `
          float: left;
          width: ${this.props.screen.isMobile ? 'auto' : formWidth - uploadwidth - padding}px;
          padding-left: ${padding};
          clear: right;
        `,
        options: {
          rules: [
            {
              required: true,
              message: 'Company Name DBA is required. ',
            },
            {
              max: 100,
              message: 'Company Name is limited to 100 characters. ',
            },
          ],
        },
      },
      {
        title: 'Contact Name',
        var: 'name',
        styles: `
          clear: both;
        `,
        options: {
          rules: [
            {
              required: true,
              message: 'Contact Name is required. ',
            },
            {
              max: 100,
              message: 'Contact Name is limited to 100 characters. ',
            },
          ],
        },
      },
      {
        title: 'Phone',
        var: 'company.phone',
        styles: `
          clear: both;
        `,
        options: {
          validateTrigger: 'onBlur',
          rules: [
            {
              required: true,
              message: 'Phone is required. ',
            },
            {
              validator: (rule, value, cb) => {
                const passes = !value || validPhoneNumber(value);
                cb(passes ? undefined : rule.message);
              },
              message: 'Phone needs to be a valid phone number. ',
            },
            {
              max: 16,
              message: 'Phone is limited to 16 characters. ',
            },
          ],
        },
      },
      {
        title: 'Billing Contact Name',
        var: 'company.billingContactName',
        canDisplay: () => !userHasRole(2, this.props.sState),
        styles: `
          clear: both;
        `,
        options: {
          rules: [
            {
              required: true,
              message: 'Billing Contact Name is required. ',
            },
          ],
        },
      },
      {
        title: 'Billing Contact Email',
        var: 'company.billingContactEmail',
        canDisplay: () => !userHasRole(2, this.props.sState),
        styles: `
          clear: both;
        `,
        options: {
          rules: [
            {
              required: true,
              message: 'Billing Contact Email is required. ',
            },
            {
              type: 'email',
              message: 'The input is not a valid E-mail. ',
            },
          ],
        },
      },
      {
        title: 'Billing Address',
        var: 'company.billingAddress',
        canDisplay: () => !userHasRole(2, this.props.sState),
        styles: `
          clear: both;
        `,
        options: {
          rules: [
            {
              required: true,
              message: 'Billing Address is required. ',
            },
          ],
        },
      },
      {
        title: 'License Number',
        var: 'company[License #]',
        getType: () => {
          const isAdmin = userHasRole([0, 1], this.props.sState);
          // Admins/superadmins (role 0/1) get the searchable license lookup on
          // BOTH create and edit account (card #221 R2). Other roles keep the
          // plain/disabled text input.
          return isAdmin ? 'lnsearch_single' : undefined;
        },
        canDisplay: () => !userHasRole(2, this.props.sState),
        styles: `
          clear: both;
        `,
        props: () => {
          const isAdmin = userHasRole([0, 1], this.props.sState);
          if (isAdmin) {
            return { allowEdit: true };
          }
          return {
            disabled: !get(this, 'state.isNewUser', false) && !isAdmin,
          };
        },
        options: {
          rules: [
            {
              required: true,
              message: 'License Number is required. ',
            },
          ],
        },
      },
      {
        title: userHasRole(3, this.props.sState) ? 'Request Additional License Numbers' : 'Additional License Numbers',
        var: 'company.licenseNumbers',
        canDisplay: () => !userHasRole(2, this.props.sState),
        type: 'lnsearch',
        styles: `
          clear: both;
        `,
        props: () => {
          const isStandardUser = userHasRole(4, this.props.sState);
          const viewedUserLicense = get(this.state.user, 'company.License #', '');
          // Own licenses (already held) + licenses held by ANY other user globally.
          // The backend (getLicensesAssignedToOthers) already excludes this user's
          // own licenses and legitimate role-4 subaccount sharing of the primary LN.
          const ownLicenses = viewedUserLicense
            ? [viewedUserLicense, ...get(this.state.user, 'company.licenseNumbers', [])]
            : get(this.state.user, 'company.licenseNumbers', []);
          const assignedToOthers = get(this.state, 'assignedToOthers', []);
          return {
            disabled: isStandardUser,
            disabledOpts: [...new Set([...ownLicenses, ...assignedToOthers])],
            _tooltip: isStandardUser ? 'Please contact Account Admin to add a License' : null,
          };
        }
      },
      {
        title: 'Street Address',
        var: 'company[Street Address]',
        canDisplay: () => !userHasRole(2, this.props.sState),
        styles: `
          clear: both;
        `,
        options: {
          rules: [
            {
              required: true,
              message: 'Street Address is required. ',
            },
          ],
        },
      },
      {
        title: 'Signature',
        var: 'signature',
        type: 'sigpad',
        canDisplay: () => getConfig('sigs.show') && userHasRole([0, 1, 2], this.props.sState) && !this.state.isNewUser && !this.state.isCreate,
        styles: `
          clear: both;
        `,
        props: {
          onSave: result => {
            const { form } = this.props;
            form.setFieldsValue({ signature: { ...result, date: new Date().toISOString() } });
          }
        }
      },
      {
        title: 'Do you want to receive order notifications?',
        var: 'alerts.email',
        type: 'dropdown',
        styles: `
          clear: both;
        `,
        opts: [
          { title: 'Yes', value: true },
          { title: 'No', value: false },
        ],
        placeholder: 'Yes',
        options: {
          initialValue: true,
        }
      },
      {
        title: 'Public Orders Link',
        var: 'publicorderslink',
        styles: `
          clear: both;
        `,
        val: () => this.externalLink(),
        canDisplay: () => userHasRole([0, 1], this.props.sState),
        options: {
        },
        props: {
          disabled: true,
          addonAfter: <Icon type="copy" onClick={() => {
            copyToClipboard(this.externalLink())
            message.success('Link copied successfully!')
          }} />
        }
      },
      {
        title: 'Verified',
        var: 'verified',
        type: 'dropdown',
        canDisplay: () => userHasRole([0, 1], this.props.sState),
        styles: `
          clear: both;
        `,
        opts: VERIFIYOPTIONS
      },
      {
        title: 'Same Day Pickup Allowed',
        var: 'sameDayPickup',
        type: 'dropdown',
        canDisplay: () => userHasRole([0, 1], this.props.sState),
        styles: `
          clear: both;
        `,
        opts: [
          { title: 'Allowed', value: true },
          { title: 'Not Allowed', value: false },
        ]
      },
      {
        // Card #256 — Payment enforcement. Per-account gate: when "Allowed",
        // accounts created by this user expose a per-order "Payment Required?"
        // checkbox on the order form (order.component.jsx). Persists to
        // data.paymentRequirement (the whole flat user is stored as the
        // users.data JSONB by users.js /update — same path as sameDayPickup).
        // Round 4 — renamed off "COD" per Danielle 7/28 + the annotated mockup.
        // Round 7 — gated behind the master switch (Edit Settings >
        // `orders.paymentRequirementEnabled`, default OFF on every environment).
        // Danielle 2026-08-11: "if toggled on the Payment Requirement for
        // Delivery shows up on the Account Profiles - If toggled off then this
        // field is not displayed anywhere on the platform." The master flag is
        // an ADDITIONAL `&&` in front of the existing role rule — with it on,
        // behaviour is exactly what it was before round 7.
        title: 'Payment Requirement for Delivery',
        var: 'paymentRequirement',
        type: 'dropdown',
        canDisplay: () => getConfig('orders.paymentRequirementEnabled', false) && userHasRole([0, 1, 3], this.props.sState),
        styles: `
          clear: both;
        `,
        opts: [
          { title: 'Allowed', value: true },
          { title: 'Not Allowed', value: false },
        ]
      },
      {
        // Card #256 round 4 — the account's default payment contact. Surfaces
        // only while the requirement is ON, and is REQUIRED there ("If Allowed
        // then the two bottom fields are required" — mockup panel 1). Standard
        // Users (role 4) never see the dropdown itself but do see these, since
        // the order-screen hover disclaimer sends them here to correct the
        // values; their setting is inherited account-wide (users.js/passport).
        title: 'Payment Required Contact Name',
        var: 'paymentContactName',
        canDisplay: () => this.canDisplayPaymentContact(),
        styles: `
          clear: both;
        `,
        props: { placeholder: 'Name' },
        options: () => ({
          // Seeded here rather than relying solely on setFieldsOriginal: with
          // the requirement off at load these fields are not rendered, so they
          // are not yet registered and rc-form silently drops a setFieldsValue
          // aimed at them. initialValue lands the stored value at registration,
          // i.e. the moment the setting is switched to Allowed.
          initialValue: get(this, 'state.user.paymentContactName'),
          rules: [
            {
              required: this.paymentRequirementOn(),
              message: 'Payment Required Contact Name is required. ',
            },
            {
              max: 100,
              message: 'Payment Required Contact Name is limited to 100 characters. ',
            },
          ],
        }),
      },
      {
        // Card #256 round 4 — companion phone. Same validity rules as the
        // account's main Phone field so both accept the same formats.
        title: 'Payment Required Contact Phone #',
        var: 'paymentContactPhone',
        canDisplay: () => this.canDisplayPaymentContact(),
        styles: `
          clear: both;
        `,
        props: { placeholder: 'Number' },
        options: () => ({
          // See the contact-name field above for why initialValue is used here.
          initialValue: get(this, 'state.user.paymentContactPhone'),
          validateTrigger: 'onBlur',
          rules: [
            {
              required: this.paymentRequirementOn(),
              message: 'Payment Required Contact Phone # is required. ',
            },
            {
              validator: (rule, value, cb) => {
                const passes = !value || validPhoneNumber(value);
                cb(passes ? undefined : rule.message);
              },
              message: 'Payment Required Contact Phone # needs to be a valid phone number. ',
            },
            {
              max: 16,
              message: 'Payment Required Contact Phone # is limited to 16 characters. ',
            },
          ],
        }),
      },
      {
        title: 'Label Format',
        var: 'labelFormat',
        type: 'dropdown',
        canDisplay: () => !this.state.editAccount || userHasRole([0, 1, 3], this.props.sState),
        styles: `
          clear: both;
        `,
        val: (user) => get(user, 'labelFormat', 'standard'),
        opts: [
          { title: 'Standard Label - 8.5x11', value: 'standard' },
          {
            title: 'Label Roll - 4 x 4',
            value: 'roll',
            tooltip: `For more information about Label Printers Please email ${getConfig('labelPrinters.supportEmail', 'info@gpsone.delivery')}.`,
          },
        ]
      },
      {
        title: 'Role',
        var: 'role',
        type: 'dropdown',
        canDisplay: () => userHasRole([0, 1], this.props.sState),
        styles: `
          clear: both;
        `,
        props: () => ({
          disabled: parseInt(get(this, 'props.sState.user.role', 0)) > parseInt(get(this, 'state.user.role', 4)),
        }),
        opts: (() => {
          const currentRole = get(this, 'props.sState.user.role');
          return Object.keys(ROLES).filter(k => {
            const val = parseInt(k);
            return val >= currentRole;
          }).map(k => ({ title: ROLES[k], value: parseInt(k) }))
        })()
      },
    ]
  };
  componentDidUpdate(pProps) {
    const compKey = 'sState.user.company.licenseNumbers';
    if (get(pProps, compKey) !== get(this.props, compKey)) {
      this.setState({ user: get(this, 'props.sState.user', {}) }, this.setFieldsOriginal);
    }
  }
  canAddLNS = () => {
    return userHasRole([0,1,2,3], this.props.sState);
  }
  // Card #256 round 4 — is the payment requirement IN EFFECT for the profile
  // being edited? Prefers the live dropdown value (roles 0/1/3 can toggle it in
  // this same form) and falls back to the loaded user's stored/inherited
  // setting, which is the only source a Standard User has.
  //
  // Round 7 — the master switch (Edit Settings >
  // `orders.paymentRequirementEnabled`, default OFF) short-circuits this to
  // false, which is the SINGLE place the gate is needed for the contact fields:
  // this predicate drives BOTH canDisplayPaymentContact() below AND the
  // `required: this.paymentRequirementOn()` rules on the two contact fields, so
  // one read cannot leave them hidden-but-required. This is deliberately a
  // "requirement in effect" answer, NOT "what is stored on the account" —
  // stored data is untouched by the switch, so read state.user.paymentRequirement
  // directly if you ever need the raw value.
  paymentRequirementOn = () => {
    if (!getConfig('orders.paymentRequirementEnabled', false)) { return false; }
    const live = this.props.form.getFieldValue('paymentRequirement');
    return live === undefined ? !!get(this, 'state.user.paymentRequirement') : !!live;
  }
  // Payment contact fields ride along with the requirement: shown only while it
  // is on, and hidden from drivers (role 2), who have no account of their own.
  // The round-7 master switch reaches these through paymentRequirementOn()
  // above — with it off that returns false, so these two fields never render
  // even for an account whose stored paymentRequirement is still true.
  canDisplayPaymentContact = () => (
    userHasRole([0, 1, 3, 4], this.props.sState) && this.paymentRequirementOn()
  )
  handleSelectChange = async (e, item, dir = 'add') => {
    if (!e) { return };

    const isLicenseField = item.var === 'company.licenseNumbers';
    const isAccountAdmin = userHasRole(3, this.props.sState);

    // Role 3 on license field: send request instead of direct modification
    // But during account creation, allow direct additions (pending workflow only applies after account exists)
    if (isLicenseField && isAccountAdmin && !this.state.isNewUser) {
      try {
        const userId = get(this, 'state.fullUser.id') || get(this, 'state.user.id');
        const result = await requestLicenseChange(userId, e, dir === 'add' ? 'add' : 'remove');
        if (result.status === 'pending') {
          message.success('License request submitted for approval');
          // Add to local pending state for visual feedback
          const user = { ...this.state.user, company: { ...get(this, 'state.user.company', {}) } };
          const pendingEntry = { license: e, requestedAt: new Date().toISOString(), requestedBy: '' };
          if (dir === 'add') {
            user.company.pendingLicenseNumbers = [
              ...get(user, 'company.pendingLicenseNumbers', []),
              pendingEntry,
            ];
          } else {
            user.company.pendingLicenseRemovals = [
              ...get(user, 'company.pendingLicenseRemovals', []),
              pendingEntry,
            ];
          }
          this.setState({ user });
        }
      } catch (err) {
        message.error('Failed to submit license request');
      }
      return;
    }

    const currentTags = get(this, `state.user.${item.var}`, []);

    const comp = get(this, item.var);
    if (comp && comp.selectOption) {
      comp.selectOption('');
    }

    const { setFieldsValue } = this.props.form;

    if (dir === 'add') {
      set(this, `state.user.${item.var}`, [
        ...currentTags,
        e,
      ]);
    } else if (dir === 'remove') {
      set(this, `state.user.${item.var}`, currentTags.filter(t => t !== e));
    }

    setFieldsValue({
      [item.var]: get(this, `state.user.${item.var}`, []),
    });
  }
  externalLink = () => {
    const { user } = this.state;
    return `${config.appUrl}/dashboard/publicorders?userid=${user.id}`;
  }
  // Load the set of license numbers already assigned to OTHER users (globally)
  // so they can be greyed out and disabled in the "Additional License Numbers"
  // picker. Keyed off the viewed profile user's id.
  loadAssignedLicenses = async () => {
    try {
      const userId = get(this, 'state.fullUser.id') || get(this, 'state.user.id');
      if (!userId) { return; }
      const licenses = await getAssignedLicenses(userId);
      this.setState({ assignedToOthers: Array.isArray(licenses) ? licenses : [] });
    } catch (err) {
      // Non-fatal: fall back to no extra grey-outs if the lookup fails.
      this.setState({ assignedToOthers: [] });
    }
  };
  componentDidMount = async () => {
    const location = this.props.state ? { state: this.props.state } : get(this, 'props.history.location');
    if (location && location.state) {
      const isNewUser = get(location, 'state.newUser', false);
      const locationUser = get(location, 'state.editAccount.data');

      if (locationUser) {
        set(locationUser, 'company.logo', get(location, 'state.editAccount.logo'))
      }

      this.setState({
        isCreate: location.state.isCreate || false,
        fullUser: get(location, 'state.editAccount'),
        editAccount: location.state.editAccount ? true : false,
        user: isNewUser ? new _Account() : locationUser || this.state.user,
        isNewUser,
      }, () => { this.setFieldsOriginal(); this.loadAssignedLicenses(); });
    } else {
      this.setFieldsOriginal();
      this.loadAssignedLicenses();
    }
    if (userHasRole(0, this.props.sState)) {
      this.loadMfaStatus();
    }
  };
  loadMfaStatus = async () => {
    try {
      const status = await getMfaStatus();
      this.setState(s => ({ mfa: { ...s.mfa, status } }));
    } catch (err) {
      // non-fatal; panel just won't show status
    }
  }
  startMfaEnroll = async () => {
    try {
      this.setState(s => ({ mfa: { ...s.mfa, loading: true } }));
      const { qrDataUrl } = await enrollMfa();
      this.setState(s => ({ mfa: { ...s.mfa, qrDataUrl, loading: false } }));
    } catch (err) {
      message.error(get(err, 'response.data.error', err.message));
      this.setState(s => ({ mfa: { ...s.mfa, loading: false } }));
    }
  }
  confirmMfaActivate = async () => {
    try {
      this.setState(s => ({ mfa: { ...s.mfa, loading: true } }));
      await activateMfa(this.state.mfa.code);
      message.success('MFA activated');
      this.setState(s => ({ mfa: { ...s.mfa, qrDataUrl: null, code: '', loading: false } }));
      this.loadMfaStatus();
    } catch (err) {
      message.error(get(err, 'response.data.error', err.message));
      this.setState(s => ({ mfa: { ...s.mfa, loading: false } }));
    }
  }
  handleDisableMfa = async () => {
    try {
      await disableMfa();
      message.success('MFA disabled');
      this.setState(s => ({ mfa: { ...s.mfa, qrDataUrl: null, code: '' } }));
      this.loadMfaStatus();
    } catch (err) {
      message.error(get(err, 'response.data.error', err.message));
    }
  }
  renderMfaPanel = () => {
    const { mfa } = this.state;
    const status = mfa.status || {};
    return (
      <div css={css`margin-top: 20px; padding: 16px; border: 1px solid ${colors.tableBorder}; border-radius: 4px;`}>
        <ScreenTitle title={"Two-Factor Authentication (Superadmin)"} />
        <div css={css`margin-bottom: 10px;`}>
          Status: <b>{status.activated ? 'Activated' : status.enrolled ? 'Enrollment pending' : 'Not enrolled'}</b>
          {status.enforced ? ' (enforced)' : ''}
        </div>
        {!status.activated && !mfa.qrDataUrl && (
          <Button loading={mfa.loading} onClick={this.startMfaEnroll} title="Enroll in Authenticator App" />
        )}
        {mfa.qrDataUrl && (
          <div>
            <div css={css`margin-bottom: 8px;`}>Scan this QR code with your authenticator app, then enter the 6-digit code to activate.</div>
            <img src={mfa.qrDataUrl} alt="MFA QR Code" css={css`width: 180px; height: 180px;`} />
            <div css={css`display: flex; align-items: center; margin-top: 8px;`}>
              <Input
                style={{ width: 160, marginRight: 8 }}
                placeholder="6-digit code"
                value={mfa.code}
                onChange={e => { const value = e.target.value; this.setState(s => ({ mfa: { ...s.mfa, code: value } })); }}
              />
              <Button loading={mfa.loading} onClick={this.confirmMfaActivate} title="Activate" />
            </div>
          </div>
        )}
        {status.activated && (
          <Button onClick={this.handleDisableMfa} type="danger" title="Disable MFA" />
        )}
      </div>
    );
  }
  renderAddUserModal = () => {
    const { addUserModal } = this.state;
    return (
      <Modal
        title="Add User to this Account"
        visible={addUserModal.visible}
        confirmLoading={addUserModal.loading}
        onOk={this.submitAddUser}
        onCancel={this.closeAddUser}
        okText="Create User"
      >
        <div css={css`margin-bottom: 8px;`}>
          The new user will be created on this account with its licenses.
        </div>
        {/* Card #288 round 2: the duplicate-email rejection names the account the
            address is already on, and has to stay readable while the admin fixes
            the field — a toast alone had scrolled away by then. */}
        {!!addUserModal.error && (
          <Alert
            type="warning"
            showIcon
            closable
            message={addUserModal.error}
            onClose={() => this.setState(s => ({ addUserModal: { ...s.addUserModal, error: null } }))}
            style={{ marginBottom: 8 }}
          />
        )}
        <Input
          placeholder="Email"
          value={addUserModal.email}
          onChange={e => { const value = e.target.value; this.setState(s => ({ addUserModal: { ...s.addUserModal, email: value } })); }}
          css={css`margin-bottom: 8px;`}
        />
        <Input
          placeholder="Temp password (leave blank to auto-generate)"
          value={addUserModal.password}
          onChange={e => { const value = e.target.value; this.setState(s => ({ addUserModal: { ...s.addUserModal, password: value } })); }}
        />
        {/* Card #288: admins had nothing to go on here and were guessing at the
            temp password. These are the testPassword rules the server now
            enforces on every path that sets a password. */}
        <div css={css`margin-top: 6px; font-size: 12px; color: ${colors.labelColor};`}>
          Must be at least 6 characters and include a number, a lowercase letter and an uppercase letter.
          Leave blank to have one generated automatically.
        </div>
      </Modal>
    );
  }
  renderTempPasswordModals = () => {
    const { addUserResult, resetPwResult } = this.state;
    const result = addUserResult || resetPwResult;
    if (!result) return null;
    const closeModal = () => this.setState({ addUserResult: null, resetPwResult: null });

    // Reset Password (card #160): we emailed the user a single-use reset link,
    // so there is no password to display — show a confirmation instead.
    if (resetPwResult) {
      return (
        <Modal
          title="Reset Password"
          visible={!!result}
          onOk={closeModal}
          onCancel={closeModal}
          footer={null}
        >
          <div>
            A single-use password reset link has been emailed to <b>{result.email}</b>.
            The link is valid for 72 hours. Ask them to check their spam folder if
            it does not arrive.
          </div>
        </Modal>
      );
    }

    // Add User still surfaces a temp password (out of scope for the reset-link
    // rework — account creation, not a reset).
    return (
      <Modal
        title="User Created"
        visible={!!result}
        onOk={closeModal}
        onCancel={closeModal}
        footer={null}
      >
        <div css={css`margin-bottom: 8px;`}>
          Share this temporary password with <b>{result.email}</b>. It will not be shown again.
        </div>
        <div css={css`display: flex; align-items: center;`}>
          <code css={css`font-size: 16px; background: ${colors.disabledLight}; padding: 6px 10px; border-radius: 4px;`}>
            {result.tempPassword}
          </code>
          <Icon
            type="copy"
            css={css`margin-left: 10px; cursor: pointer; font-size: 18px; color: ${colors.highlight};`}
            onClick={() => { copyToClipboard(result.tempPassword); message.success('Copied'); }}
          />
        </div>
      </Modal>
    );
  }
  submit = async (e) => {
    e.preventDefault();
    if (this.state.loading) {
      return;
    }

    this.state.loading = true;
    this.state.error = null;
    this.setState(this.state);

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        const error = buildErrorMsgFromForm(err);
        return this.setState({ error, loading: false });
      }

      const { isNewUser } = this.state;

      try {
        const { user, imageUrl } = this.state;

        // A field whose canDisplay() is false is never passed to
        // getFieldDecorator (see render), so rc-form never registers it and it
        // is ABSENT from `values` — not present-as-undefined. lodash merge
        // keeps the target's value for an absent/undefined source key, so the
        // stored value in `user` survives untouched. That is what makes it safe
        // to hide a field rather than disable it. Card #256 round 7 leans on it
        // for `paymentRequirement`: with the master switch off the dropdown
        // does not render, and a save must NOT write false over an account that
        // has it on (server users.js fans the value out account-wide on both
        // true and false).
        const usr = merge({}, user, values, this.state.fullUser || {});

        usr.company.logo = imageUrl;

        // Keep the legacy 'Licensee DBA' key (this field's old storage) in
        // sync with the company.DBA the field now edits, so the on-load
        // preference for the legacy key never resurfaces a stale value after
        // a save (card #11 round 16).
        const typedDBA = get(values, 'company.DBA');
        if (typedDBA !== undefined) {
          set(usr, 'company.Licensee DBA', typedDBA);
        }

        const isVerified = userIsVerfied(user);

        if (isNewUser) {
          try {
            // Card #288 round 3 — the duplicate-email check belongs to the
            // server: /users/create answers 409 with a message naming the account
            // that already holds the address. A getUser() pre-check used to run
            // here first, but it compared the email EXACTLY, so the ordinary case
            // — the same address typed the same way — was turned away by the
            // client with a generic "This email already exists" and only a
            // differently-cased duplicate ever reached the message Danielle asked
            // for. One check, in one place, so this form and Add User cannot
            // disagree about what counts as a duplicate.
            await createUser({
              ...usr,
              verified: true,
            });

            // Invite only someone who now has an account. This send used to run
            // BEFORE createUser, so a create the server refused still mailed the
            // person a sign-up link for an account that was never made. A send
            // that fails must still not fail the create — the account exists
            // either way — so the handling below is unchanged.
            const html = `You have been invited to GPS One's online portal. Use the link below to sign up.

<a href="${config.appUrl}/signMeUp?email=${encodeURIComponent(usr.email)}">Sign Up</a>`;
            const email = {
              to: usr.email,
              subject: 'GPS One Service Invitation',
              html,
            };

            await sendEmail(email).catch(e => {
              console.error('failed', e);
            })

            message.success('Account created successfully!');

            this.back(true);
          } catch (err) {
            // Card #288 — /users/create refuses a duplicate email with 409 and a
            // message naming the account that holds it; err.message alone would
            // surface that as "Request failed with status code 409".
            const e = get(err, 'response.data.error', err.message);
            if (get(err, 'response.status') === 409) {
              // Round 3 — shown verbatim, not wrapped in "Account creation
              // failed: ...!": it is already a finished sentence and it is the
              // same text the Add User modal shows. The toast rides along
              // because this Alert renders at the top of a form whose Save
              // button is at the bottom, so it can land off screen.
              message.warning(e);
              return this.setState({ loading: false, error: e });
            }
            this.setState({
              loading: false,
              error: `Account creation failed: ${e}!`
            })
          }
        } else {
          await updateUser(usr);
          await this.props.getUserData();

          const justVerified = usr.verified && !user.verified;

          if (justVerified) {
            //user has become verified by admin, so send them email
            sendEmail({
              to: user.email,
              subject: 'Account Verified',
              html: `Congratulations! Your account (${usr.email}) has been verified. <br /><br />
                Login <a href="${config.appUrl}">Here</a>
                `
            })

            message.success('Account verified successfully!');
            this.setState({ loading: false });
            if (this.props.isModal) {
              this.back(true);
            } else {
              this.props.history.push('/dashboard/accounts');
            }
            return;
          }

          if (!isVerified) {
            const hasSubmittedPreviously = get(user, 'hasSentEmail');
            // Card #151 round 4 — non-null when the New User Application notice
            // could not be sent, so the applicant is told instead of the failure
            // vanishing (Danielle 2026-07-30: "We did not receive ... the New
            // User Application Email").
            let signupEmailError = null;

            if (!hasSubmittedPreviously) {
              // Card #151 round 2 — recipients are the live Admins + Super Admins
              // from the DB UNIONed with the configured signupEmails: the setting
              // can hold shared boxes (signups@) that are not user accounts, and a
              // failed lookup must not silently drop the application notice.
              const configured = getConfig('signupEmails', config.adminEmails);
              const configuredSignupEmails = Array.isArray(configured) ? configured : (configured ? [configured] : []);
              const adminEmails = await getAdminEmails().catch(() => []);
              const signupTo = uniqBy(
                [...adminEmails, ...configuredSignupEmails].filter(e => !!e && `${e}`.trim()),
                e => `${e}`.trim().toLowerCase()
              );
              // Card #151 round 4 — SEND FIRST, then persist the "already
              // notified" flag. It used to run the other way round
              // (`usr.hasSentEmail = true; await updateUser(usr)` before the
              // send), which made any failure permanent: hasSentEmail
              // short-circuits this whole block on every later submit, so the
              // application could never be re-notified and nobody was told it
              // had failed. Now a failed send leaves the flag unset, so simply
              // saving the profile again retries it.
              let notified = false;

              try {
                // Card #151: mock wording + bold-labeled applicant details; optional
                // tenant subject prefix via the emails.subjectPrefix setting.
                await sendEmail({
                  to: signupTo,
                  subject: [getConfig('emails.subjectPrefix'), 'New User Verification Required'].filter(f => !!f).join(' - '),
                  html: `
                  New User Application Requires Verification,
                  <br /><br />
                  <b>Company Name(DBA):</b> ${get(usr, 'company.DBA') || get(usr, 'company.Licensee DBA') || ''}<br />
                  <b>User Email:</b> ${usr.email}<br />
                  <b>Contact Name:</b> ${usr.name || ''}<br />
                  <b>Phone #:</b> ${get(usr, 'company.phone', '')}<br />
                  <b>License #:</b> ${get(usr, 'company.License #', '')}<br />
                  <br />
                  <a href="${config.appUrl}/validateUser?email=${usr.email}">Verify New Account</a>
                  `
                })

                notified = true;
              } catch (e) {
                // /email/sendEmail answers 500 with { error }; axios's own
                // message is only the generic status text, so prefer the body.
                const reason = get(e, 'response.data.error') || e.message;
                console.error('New User Application email failed', e);
                signupEmailError = `Your profile was saved, but the new user application notice could not be sent to an administrator (${reason}). Please contact support so your account can be reviewed — saving your profile again will retry the notice.`;
                message.error('Could not notify an administrator of your application.', 10);
              }

              if (notified) {
                usr.hasSentEmail = true;
                await updateUser(usr).catch(e => {
                  // The notice DID go out and only the bookkeeping write failed,
                  // so this must not read as an email failure to the applicant.
                  // Worst case a later resubmit mails a duplicate notice.
                  console.error('Failed to persist hasSentEmail after sending the New User Application email', e);
                });
              }
            }

            return this.setState({
              success: 'Your profile has been created successfully. Your account is being reviewed and you will receive an email (check your spam folder) once you are Validated. Thank you.',
              error: signupEmailError,
              loading: false,
              user: usr,
            })
          }

          this.setState({
            loading: false,
            success: 'Profile updated successfully!',
            user: usr,
          });

        }
        if (this.props.isModal) { this.back(true) };
        // updateSpreadsheet();
      } catch (err) {
        this.setState({
          loading: false,
          error: `Profile ${isNewUser ? 'creation' : 'update'} failed: ${err.message}!`
        })
      }
    });
  };
  beforeUpload = (file) => {
    return new Promise((resolve, reject) => {
      getBase64(file, (imageUrl) => {
        this.setState({ imageUrl });
        reject();
      })
    })
  }
  loadAttachedAccounts = async () => {
    const userlns = getAllLnsFromUser(this.state.user);
    
    const allusers = uniqBy(flatten(await Promise.all(userlns.all.map(async ln => {
      return await getUsersMatchingLn(ln);
    }))), 'id');

    this.setState({ attachedUsers: allusers })
  }
  // Card #277 — the attached accounts the grid is currently showing.
  shownAttachedUsers = () => {
    return searchTable(this.getUserCols(), this.state.attachedUsers || [], this.state.attachedSearch);
  }
  updateData = async (data, row) => {
    try {
      // EditableFormTable rebuilds from the array it was given to render, which under a
      // search is a SUBSET of the attached accounts. Writing that back unchanged would
      // drop every account the search is hiding from state — taking them off the list and
      // out of reach of the "Set all" buttons below, which read it. Stitch the hidden ones
      // back in; only a row that was actually on screen can have been removed.
      const merged = mergeTableEdits(this.state.attachedUsers || [], this.shownAttachedUsers(), data);

      this.setState({ attachedUsers: merged.data })
      await updateUser({ ...row, ...get(row, 'data', {}), data: undefined });
    } catch (err) {
      message.error('Failed to update user, please try again.')
    }
  }
  setAllSuspended = async (val) => {
    try {
      this.setState({ loading: true });
      await Promise.all(this.state.attachedUsers.map(async u => {
        set(u, 'data.verified', val);
        await updateUser({ ...u, ...get(u, 'data', {}), data: undefined });
      }))
    } catch (err) {
      message.error(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }
  // ---- Card #160: Add User / Reset Password / Impersonation ----------------
  // The "current account" whose licenses a new user inherits is the profile
  // user being viewed (or the logged-in user when not editing another account).
  accountForNewUser = () => {
    return this.state.editAccount ? get(this, 'state.fullUser.data') || this.state.user : this.state.user;
  }
  openAddUser = () => {
    this.setState({ addUserModal: { visible: true, email: '', password: '', loading: false, error: null }, addUserResult: null });
  }
  closeAddUser = () => {
    this.setState({ addUserModal: { ...this.state.addUserModal, visible: false } });
  }
  submitAddUser = async () => {
    const { email, password } = this.state.addUserModal;
    // Card #288 round 2 — every rejection also lands as an Alert inside the modal.
    // The toast is gone in three seconds, and "already in use for account (X)" is
    // the one thing the admin still needs to be reading while they retype.
    const reject = (error) => {
      message.error(error);
      this.setState(s => ({ addUserModal: { ...s.addUserModal, error, loading: false } }));
    };
    if (!email) { return reject('Email is required'); }
    // Card #288: only a password the admin actually typed is checked — blank
    // still means "let the server generate one".
    if (password && !testPassword(password)) { return reject(PWReqsMessage); }
    try {
      this.setState(s => ({ addUserModal: { ...s.addUserModal, loading: true, error: null } }));
      const account = this.accountForNewUser() || {};
      const company = get(account, 'company', {});
      // New user inherits the account's company + licenses, as a standard user (role 4).
      const newUser = {
        email,
        role: 4,
        verified: true,
        company: {
          ...company,
        },
      };
      const { tempPassword } = await createUser(newUser, password || undefined);
      this.setState({
        addUserModal: { visible: false, email: '', password: '', loading: false, error: null },
        addUserResult: { email, tempPassword },
      });
      message.success('User created successfully');
      this.loadAttachedAccounts();
    } catch (err) {
      const e = get(err, 'response.data.error', err.message);
      // Card #288 round 2 — /users/create answers 409 when the email already
      // belongs to an account, and that message names the account, so it reads
      // better on its own than behind "Failed to create user:". No user was
      // created, so it is a warning to act on rather than a failure to report.
      if (get(err, 'response.status') === 409) {
        message.warning(e);
        this.setState(s => ({ addUserModal: { ...s.addUserModal, error: e, loading: false } }));
        return;
      }
      reject(`Failed to create user: ${e}`);
    }
  }
  handleResetPassword = async (row) => {
    try {
      await resetUserPassword(row.id);
      this.setState({ resetPwResult: { email: row.email } });
      message.success(`Password reset link emailed to ${row.email}`);
    } catch (err) {
      const e = get(err, 'response.data.error', err.message);
      message.error(`Failed to send reset link: ${e}`);
    }
  }
  impersonate = async (row) => {
    try {
      const store = window.STORE;
      const current = get(store.getState(), 'user', {});
      const { token, user } = await impersonateUser(row.id);
      if (!token) { message.error('Failed to start impersonation'); return; }
      // Stash the superadmin's own session so Exit can restore it.
      localStorage.setItem('GPS_impersonation_stash', JSON.stringify({
        user: current,
        impersonating: row.email,
      }));
      const targetUser = { ...get(user, 'data', {}), email: row.email, id: row.id, token };
      store.dispatch({ type: 'SET_CURRENT_USER', payload: targetUser });
      store.dispatch({ type: 'SET_TOKEN', token });
      // Persist the impersonated user slice directly so a full reload (which
      // re-hydrates from redux-persist) picks it up without a flush race.
      try {
        const persisted = JSON.parse(localStorage.getItem('persist:GPS_root') || '{}');
        const userSlice = JSON.parse(persisted.user || '{}');
        persisted.user = JSON.stringify({ ...userSlice, ...targetUser, token });
        localStorage.setItem('persist:GPS_root', JSON.stringify(persisted));
      } catch (e) { /* fall back to dispatched state */ }
      window.location.href = '/dashboard';
    } catch (err) {
      const e = get(err, 'response.data.error', err.message);
      message.error(`Failed to impersonate: ${e}`);
    }
  }
  // Builds the Attached Accounts table columns: base USER_COLS plus role-gated
  // action columns (Login As User for admins and superadmins; Reset Password for
  // admins and superadmins). Admins/superadmins can never impersonate a
  // superadmin — enforced per-row below (and on the server).
  getUserCols = () => {
    const { sState } = this.props;
    const isAdminOrSuper = userHasRole([0, 1], sState);

    const cols = [...USER_COLS];

    if (isAdminOrSuper) {
      cols.push({
        title: 'Login As User',
        dataIndex: '__impersonate',
        render: (text, row) => {
          const targetIsSuper = get(row, 'data.role') === 0;
          if (targetIsSuper) {
            return (
              <Tooltip title="Superadmins cannot be impersonated">
                <Icon type="user-delete" css={css`color: ${colors.disabledColor}; font-size: 18px;`} />
              </Tooltip>
            );
          }
          return (
            <Tooltip title={`Login as ${row.email}`}>
              <Icon
                type="login"
                css={css`color: ${colors.highlight}; cursor: pointer; font-size: 18px;`}
                onClick={(e) => { e.stopPropagation && e.stopPropagation(); this.impersonate(row); }}
              />
            </Tooltip>
          );
        }
      });
    }

    if (isAdminOrSuper) {
      cols.push({
        title: 'Reset Password',
        dataIndex: '__resetpw',
        render: (text, row) => (
          <Tooltip title={`Reset password for ${row.email}`}>
            <Icon
              type="key"
              css={css`color: ${colors.highlight}; cursor: pointer; font-size: 18px;`}
              onClick={(e) => { e.stopPropagation && e.stopPropagation(); this.handleResetPassword(row); }}
            />
          </Tooltip>
        )
      });
    }

    return cols;
  }
  approveLicense = async (userId, license, action, decision) => {
    try {
      const resolvedUserId = get(this, 'state.fullUser.id');
      if (!resolvedUserId) {
        message.error('Unable to determine user ID for approval');
        return;
      }
      await approveLicenseChange(resolvedUserId, license, action, decision);
      const decisionText = decision === 'approve' ? 'approved' : 'rejected';
      message.success(`License ${action} ${decisionText}`);
    } catch (err) {
      const errMsg = get(err, 'response.data.error') || err.message || 'Failed to process license request';
      message.error(errMsg);
      return;
    }
    // Refresh user data (separate from approval so a refresh failure doesn't mask success)
    try {
      if (this.state.editAccount && this.state.fullUser) {
        const refreshed = await getUserById(this.state.fullUser.id, { returnRaw: true });
        this.setState({
          fullUser: refreshed,
          user: get(refreshed, 'data', {}),
        }, this.setFieldsOriginal);
      } else {
        await this.props.getUserData();
        this.setState({ user: this.props.sState.user }, this.setFieldsOriginal);
      }
    } catch (err) {
      // Approval succeeded but refresh failed - just reload
      console.error('License approved but failed to refresh:', err);
    }
  }
  setFieldsOriginal = () => {
    const { toDisplay, user } = this.state;
    const {
      form: { setFieldsValue },
    } = this.props;
    
    toDisplay.map(item => {
      const val = item.val ? item.val(user) : get(user, item.var);
      setFieldsValue({ [item.var]: val });
      if (item.var === 'company.logo') {
        const logoVal = val || get(user, 'logo');
        if (logoVal) {
          this.setState({ imageUrl: logoVal });
        }
      }
    });

    this.setState({ loading: false }, () => {
      if (userHasRole([0, 1], this.props.sState)) {
        this.loadAttachedAccounts();
      }
    })
  };
  navigate = (cb, shouldUpdate) => {
    const { isModal, onClose } = this.props;
    if (isModal && onClose) {
      onClose(shouldUpdate);
    } else {
      cb();
    }
  }
  back = (shouldUpdate) => {
    this.navigate(this.props.history.goBack, shouldUpdate);
  }
  deleteUser = async () => {
    Modal.confirm({
      title: 'Delete User?',
      content: 'Are you sure you want to delete this user? This cannot be undone.',
      onCancel: () => 0,
      onOk: async () => {
        try {
          this.setState({ loading: true });
          await deleteUser(this.state.fullUser);
          message.success('User deleted');
          this.back(true);
        } catch (err) {
          const message = get(err, 'response.data.error', err.message);
          this.setState({
            error: `Error deleting user: ${message}!`
          });
        } finally {
          this.setState({ loading: false });
        }
      }
    });
  }
  render() {
    const { form: { getFieldDecorator }, sState, isModal, screen } = this.props;
    const { 
      error,
      success,
      loading,
      toDisplay,
      imageUrl,
      user,
      isCreate,
      editAccount,
      isNewUser,
      attachedUsers,
    } = this.state;

    const uploadButton = (
      <div>
        <Icon type={loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <div className="Profile" css={css(SStyles.container, styles.container)}>
        {isCreate && !isNewUser && <div css={css(SStyles.logoWrap)}>
          <Logo />
        </div>}

        {isCreate && !isNewUser && <NumberedHeader cols={Cols} />}

        {editAccount && !isModal && <Row css={css(`align-items: flex-start;`)}>
          <Link onClick={() => this.back()}>{'< Back'}</Link>  
        </Row>}

        {!isCreate && <ScreenTitle title={editAccount ? "Edit Account" : "My Profile"} />}
        
        {isNewUser && <ScreenTitle title={"Create New Account"} />}

        {!!error && (
          <Alert
            message={error}
            type={'error'}
            closable
            css={css(styles.alertMargin)}
            onClose={() => this.setState({ error: null })}
          />
        )}

        {!!success && (
          <Alert
            message={success}
            type={'success'}
            closable
            css={css(styles.alertMargin)}
            onClose={() => this.setState({ success: null })}
          />
        )}

        <div css={css(SStyles.formContainer, styles.formContainer, screen.isMobile && `width: 100%;`)}>
          <Form layout="vertical" onSubmit={this.submit}>
            {toDisplay.map((item, i) => {
            const canDisplay = item.canDisplay ? item.canDisplay() : true;
            const props = typeof item.props == 'function' ? item.props() : item.props;
            const itemType = item.getType ? item.getType() : item.type;
            // Card #256 round 4 — allow `options` to be a function so a field's
            // validation rules can depend on live form state (the payment
            // contact fields are required only while the requirement is on).
            const itemOptions = typeof item.options === 'function' ? item.options() : item.options;
            return !canDisplay ? null : (
              <Form.Item key={i} label={item.title} css={css(item.styles)}>
                <div>
                  {getFieldDecorator(item.var, itemOptions)(
                    itemType === 'dropdown' && item.opts ? (
                      <Select {...(props || {})} placeholder={item.placeholder} >
                        {item.opts.map((opt, i) => (
                          <Select.Option key={i} value={opt.value} title={opt.tooltip || undefined}>
                            {opt.tooltip ? (
                              <Tooltip title={opt.tooltip} placement="right">
                                <span css={css`display: inline-block; width: 100%;`}>{opt.title}</span>
                              </Tooltip>
                            ) : opt.title}
                          </Select.Option>
                        ))}
                      </Select>
                    ) : itemType === 'imageupload' ? (
                        <Upload
                          accept={'image/x-png,image/gif,image/jpeg'}
                          name="avatar"
                          listType="picture-card"
                          className="avatar-uploader"
                          showUploadList={false}
                          beforeUpload={this.beforeUpload}
                        >
                          {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                        </Upload>
                    ) : itemType === 'lnsearch_single' ? (
                        <LNSearch
                          ref={comp => set(this, item.var, comp)}
                          onSelect={(e) => {
                            if (e) {
                              this.props.form.setFieldsValue({ [item.var]: e });
                            }
                          }}
                          {...(props || {})}
                        />
                    ) : itemType === 'sigpad' ? <Sigpad {...(props || {})} {...(loading ? {} : get(user, `${item.var}`, {}))} /> : itemType === 'lnsearch' ? (
                      <Tooltip title={get(props, '_tooltip') || ''} placement="top">
                      <div style={get(props, '_tooltip') ? { opacity: 0.6, cursor: 'not-allowed' } : {}}>
                        <LNSearch
                          ref={comp => set(this, item.var, comp)}
                          onSelect={(e) => this.handleSelectChange(e, item)}
                          canAdd={this.canAddLNS()}
                          {...(props || {})}
                        />
                        <div css={css`
                          margin-top: 5px;
                          align-items: flex-start;
                          display: flex;
                          flex-wrap: wrap;
                        `}>
                          {(Array.isArray(get(user, item.var, [])) ? get(user, item.var, []) : []).filter(ln => ln !== get(user, 'company.License #')).map(ln => {
                            const pendingRemovals = get(user, 'company.pendingLicenseRemovals', []);
                            const isPendingRemoval = pendingRemovals.some(p => p.license === ln);
                            return (
                              <Tag
                                css={css`
                                  margin-bottom: 5px;
                                `}
                                color={isPendingRemoval ? colors.warning : colors.tagDark}
                                key={ln}
                                closable={!isPendingRemoval && !get(props, '_tooltip')}
                                onClose={() => this.handleSelectChange(ln, item, 'remove')}
                              >
                                {ln}{isPendingRemoval ? ' (pending removal)' : ''}
                              </Tag>
                            )
                          })}
                        </div>
                        {/* Pending license additions */}
                        {get(user, 'company.pendingLicenseNumbers', []).length > 0 && (
                          <div css={css`margin-top: 5px;`}>
                            <div css={css`font-size: 12px; color: ${colors.warning}; margin-bottom: 4px;`}>
                              Pending Approval:
                            </div>
                            <div css={css`display: flex; flex-wrap: wrap;`}>
                              {get(user, 'company.pendingLicenseNumbers', []).map(p => (
                                <Tag
                                  css={css`margin-bottom: 5px;`}
                                  color={colors.warning}
                                  key={p.license}
                                >
                                  {p.license} (pending approval)
                                </Tag>
                              ))}
                            </div>
                          </div>
                        )}
                        {/* Admin approval UI for pending additions */}
                        {userHasRole([0, 1], sState) && get(user, 'company.pendingLicenseNumbers', []).length > 0 && (
                          <div css={css`margin-top: 8px; padding: 8px; background: ${colors.warningLight}; border-radius: 4px;`}>
                            <div css={css`font-weight: bold; margin-bottom: 4px;`}>Pending License Additions:</div>
                            {get(user, 'company.pendingLicenseNumbers', []).map(p => (
                              <div key={p.license} css={css`display: flex; align-items: center; margin-bottom: 4px;`}>
                                <span css={css`margin-right: 8px;`}>{p.license}</span>
                                <Tooltip title="Approve">
                                  <Icon
                                    type="check-circle"
                                    css={css`color: ${colors.success}; cursor: pointer; margin-right: 6px; font-size: 16px;`}
                                    onClick={() => this.approveLicense(user.id, p.license, 'add', 'approve')}
                                  />
                                </Tooltip>
                                <Tooltip title="Reject">
                                  <Icon
                                    type="close-circle"
                                    css={css`color: ${colors.error}; cursor: pointer; font-size: 16px;`}
                                    onClick={() => this.approveLicense(user.id, p.license, 'add', 'reject')}
                                  />
                                </Tooltip>
                              </div>
                            ))}
                          </div>
                        )}
                        {/* Admin approval UI for pending removals */}
                        {userHasRole([0, 1], sState) && get(user, 'company.pendingLicenseRemovals', []).length > 0 && (
                          <div css={css`margin-top: 8px; padding: 8px; background: ${colors.warningLight}; border-radius: 4px;`}>
                            <div css={css`font-weight: bold; margin-bottom: 4px;`}>Pending License Removals:</div>
                            {get(user, 'company.pendingLicenseRemovals', []).map(p => (
                              <div key={p.license} css={css`display: flex; align-items: center; margin-bottom: 4px;`}>
                                <span css={css`margin-right: 8px;`}>{p.license}</span>
                                <Tooltip title="Approve Removal">
                                  <Icon
                                    type="check-circle"
                                    css={css`color: ${colors.success}; cursor: pointer; margin-right: 6px; font-size: 16px;`}
                                    onClick={() => this.approveLicense(user.id, p.license, 'remove', 'approve')}
                                  />
                                </Tooltip>
                                <Tooltip title="Reject Removal">
                                  <Icon
                                    type="close-circle"
                                    css={css`color: ${colors.error}; cursor: pointer; font-size: 16px;`}
                                    onClick={() => this.approveLicense(user.id, p.license, 'remove', 'reject')}
                                  />
                                </Tooltip>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      </Tooltip>
                    ) : item.type === 'multiselectsearch' ? (
                      <MultiSelectSearch
                        onTagsChange={tags => {
                          set(user, item.var, tags);
                        }}
                        dataSource={item.data()}
                        selected={get(user, item.var, [])}
                      />
                    ) : (
                      <Input {...(props || {})} />
                    )
                  )}
                </div>
              </Form.Item>
            );
          })}

          <Form.Item>
            <div css={css(styles.buttonContainer)}>
              <Button
                loading={loading}
                onClick={this.submit}
                type={"primary"}
                css={css(styles.button)}
              >
                {'Save'}
              </Button>

              {userHasRole([0, 1], sState) && editAccount && <Button
                loading={loading}
                onClick={this.deleteUser}
                type={"danger"}
                css={css(styles.deleteButton)}
              >
                {'Delete'}
              </Button>}

              {userHasRole(0, sState) && editAccount && (() => {
                const profileUser = this.state.fullUser || this.state.user || {};
                const targetIsSuper = get(profileUser, 'data.role') === 0;
                if (targetIsSuper) {
                  return (
                    <Tooltip title="Superadmins cannot be impersonated">
                      <Button disabled type={"primary"} css={css(styles.button)}>
                        {'Login As User'}
                      </Button>
                    </Tooltip>
                  );
                }
                return (
                  <Button
                    type={"primary"}
                    css={css(styles.button)}
                    onClick={() => this.impersonate({
                      id: profileUser.id,
                      email: profileUser.email || get(profileUser, 'data.email'),
                      data: profileUser.data,
                    })}
                  >
                    {'Login As User'}
                  </Button>
                );
              })()}
            </div>
          </Form.Item>
        </Form>
        </div>
        
        {userHasRole(0, sState) && !editAccount && !this.state.isNewUser && this.renderMfaPanel()}

        {!!attachedUsers && <div>
          <ScreenTitle title={"Attached Accounts"} />
          <Row style={{ justifyContent: 'space-between' }}>
            {userHasRole([0, 1], sState)
              ? <Button title="Add User" onClick={this.openAddUser} />
              : <div />}
            <Row>
              <Button title="Set all suspended" loading={this.state.loading} onClick={() => this.setAllSuspended('suspended')} />
              <Button style={{ marginLeft: 5 }} title="Set all verified" loading={this.state.loading} onClick={() => this.setAllSuspended(true)} />
            </Row>
          </Row>
          {/* Card #277 — the "Set all" buttons above deliberately keep operating on the
              whole list, not on the search hits: they say "all", and the roster they read
              is state, not what the grid happens to be showing. */}
          <Input.Search
            placeholder="Search all columns"
            value={this.state.attachedSearch}
            allowClear
            style={{ width: '40%', marginTop: 10, marginBottom: 10 }}
            onChange={e => { const attachedSearch = e.target.value; this.setState({ attachedSearch }); }}
          />

          <EditableFormTable
            data={this.shownAttachedUsers()}
            updateData={this.updateData}
            columns={this.getUserCols()}
            rowKey="id"
            canAdd={false}
          />
        </div>}

        {this.renderAddUserModal()}
        {this.renderTempPasswordModals()}
      </div>
    );
  }
}

export const Profile = ScreenComponent(Form.create()(withRouter(ProfileComponent)));
